import React, { useState, Component } from "react";
import PropTypes from "prop-types";
import { AiOutlineCloseCircle } from "react-icons/ai";
import {
  Menu,
  Divider,
  Button,
  Input,
  Grid,
  Container,
  Dropdown,
  Segment,
  Icon,
} from "semantic-ui-react";
import { ImageItem, SearchFeild, ButtonItem } from "../components";
import Link from "next/link";
import PlacesAutocomplete from "react-places-autocomplete";
import Head from "next/head";
import { useMediaQuery } from "react-responsive";

var localStorage = require("localStorage");

const onError = (status, clearSuggestions) => {};

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 }); // matches "onlyComputer"
  return isDesktop ? children : null;
};

class Nav extends React.PureComponent {
  constructor(props) {
    super(props);
    this.suggestiondata = [];
    this.ref = React.createRef();

    this.state = {
       mounted: false,
      isMobile: false,
      isTablet: false,
      searchValue: "",
      isTermelyload: false,
    };
  }
  handleWindowSizeChange = () => {
    this.setState({ mounted: true });
    this.setState({ isTablet: window.innerWidth <= 991 });
    this.setState({ isMobile: window.innerWidth <= 767 });
  };

  resize = () => this.forceUpdate();

  closetermlyfunction = () => {
    document.getElementById("termly-code-snippet-support").style.display =
      "none";
    localStorage.setItem("isclosetermly", true);
  };
  componentDidMount() {
    this.handleWindowSizeChange();
    // this.setState({ isTermelyload: true });
    // setTimeout(() => {
    //   this.modifyCookies();
    // }, 1500);
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  modifyCookies() {
    if (this.state.isMobile) {
      var referenceNode = document.querySelector(
        ".termly-styles-message-801455"
      );
    } else {
      var referenceNode = document.querySelector(
        ".termly-styles-content-b79ae6"
      );
    }
    var referenceNodeclose = document.querySelector(
      ".termly-styles-main-1d1c7d"
    );

    var chnagetextNode = document.querySelector(
      ".termly-styles-message-801455"
    );

    if (
      referenceNodeclose &&
      referenceNodeclose !== undefined &&
      referenceNodeclose !== null
    ) {
      var newNode1 = document.createElement("div");
      if (this.state.isMobile) {
        newNode1.style.cssText = "width:100%;margin-bottom:15px;";
      }
      newNode1.innerHTML = "<span id='closeicontermly'>X</span>";
      newNode1.onclick = this.closetermlyfunction;
      newNode1.className = "closetermelymain";
      // Insert the new node before the reference node
      referenceNode.after(newNode1);
    }
    if (
      chnagetextNode &&
      chnagetextNode !== undefined &&
      chnagetextNode !== null
    ) {
      chnagetextNode.innerHTML = "";
      chnagetextNode.innerHTML =
        'This website uses cookies to improve user experience and analyze website traffic. By clicking “Accept" or continuing to use this site, you agree to their use. Learn more about our use of cookies and how to restrict usage in our Cookie Policy. By visiting this website and using its services, you agree to the <a href="/Terms" title="Terms">Terms of Service</a>';
    }
    // if (
    //   referenceNode &&
    //   referenceNode !== undefined &&
    //   referenceNode !== null
    // ) {
    //   // Create a new element
    //   var newNode = document.createElement("div");
    //   if (this.state.isMobile) {
    //     newNode.style.cssText = "width:100%;margin-bottom:15px;";
    //   }
    //   newNode.innerHTML =
    //     "By visiting this website and using its services, you agree to the <a href='/Terms'>Terms of Service</a>";
    //   // Insert the new node before the reference node
    //   referenceNode.after(newNode);
    // }
  }

  render() {
    let bottomtabwidth;
    if (this.props.nhmap) {
      bottomtabwidth = this.props.bottomtabwidth;
    } else {
      bottomtabwidth = this.props.bottomtabwidth;
    }
    let gmapsLoaded = this.props.gmapsLoaded;
    let homeclick = this.props.homeclick;
    let address = this.props.address;
    let search = this.props.search;
    let button = this.props.button;
    let onChange = this.props.onChange;
    let handleCloseIconClick = this.props.handleCloseIconClick;
    let onClick = this.props.onClick;
    let onSelect = this.props.onSelect;
    let username = this.props.username;
    let returnemail = this.props.returnemail;
    let page = this.props.page;
    let nhmap = this.props.nhmap;
    let resultdata = this.props.resultdata;
    let homeresultdata = this.props.homeresultdata;
    let addresslength = this.props.addresslength;
    let displaydata = this.props.displaydata;
    let loadingtext = this.props.loadingtext;
    let onkeydown = this.props.onkeydown;
    let userInput = this.props.userInput;
    let newsuggestions = this.props.newsuggestions;
    let newsuggestion_length = this.props.newsuggestion_length;
    let activeSuggestion = this.props.activeSuggestion;
    let showSuggestions = this.props.showSuggestions;
    let handleSelect = this.props.handleSelect;
    let searchref = this.props.searchref;
    let handlelength = this.props.handlelength;
    let ishome = this.props.ishome;
    let redirecturl = this.props.redirecturl;
    let tagline = this.props.tagline;
    let searchquery = this.props.searchquery;
    let is_loaded = this.props.is_loaded;
    let checknodata = false;
    //resultdata = [...resultdata, ...homeresultdata];

    let urls;

    if (
      localStorage.getItem("redirecturl") &&
      localStorage.getItem("redirecturl") != null &&
      !localStorage.getItem("redirecturl").includes(null)
    ) {
      urls = localStorage.getItem("redirecturl");
    } else {
      urls = "/?address=San Francisco, CA, USA";
    }

    let loaderdisplay;
    if (loadingtext === "visible") {
      loaderdisplay = "block";
    } else {
      loaderdisplay = "none";
    }

    let filladdress;

    if (userInput != "") {
      filladdress = userInput;
    } else {
      filladdress = address;
    }
    let dataarr = [];
    const unique = [];
    let result = [];
    let count = 0;
    const { isMobile, isTablet } = this.state;
    const isclosedtermly = localStorage.getItem("isclosetermly");

    if (!this.state.mounted) {
      return null; // or return a lightweight skeleton
    }

    return (
      <>
        <Head>
          {/* {this.state.isTermelyload && isclosedtermly !== "true" && (
            <script
              type="text/javascript"
              src="https://app.termly.io/embed.min.js"
              data-auto-block="off"
              data-website-uuid="5f68f2ef-68be-4279-aa51-21733c3ad7d7"
            ></script>
          )} */}
        </Head>
        <div className="map-home-navbar">
          <div className="navbar-container">
            <div className="nav-section-logo">
              <div className="nav-logo">
                <div className="nav-img-wrapper">
                  <a
                    href="/?address=San Francisco, CA, USA"
                    title="Go to home page"
                  >
                    {!isMobile ? (
                      <ImageItem
                        source={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/houseberry-desktop.png`}
                        className="logo_img logo-image-desktop"
                        alt="Houseberry Logo"
                        title="houseberry logo"
                        width="1900"
                        height="225"
                      />
                    ) : (
                      <ImageItem
                        source={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/houseberry-mobile.svg`}
                        className="logo_img"
                        alt="Houseberry Logo"
                        title="houseberry logo"
                        width="925"
                        height="24"
                      />
                    )}
                  </a>
                </div>
                {/* {tagline && <p>there is going to be a tagline later</p>} */}
              </div>
              <div className="map-search-bar">
                {/*{this.props.showTitle ? <Menu.Item><HeaderText showTitle={this.props.showTitle} headerText={this.props.headerText} /></Menu.Item> : null}*/}
                {search ? (
                  <Menu.Item fitted>
                    {gmapsLoaded && (
                      <PlacesAutocomplete
                        value={filladdress}
                        onChange={onChange}
                        shouldFetchSuggestions={addresslength > 1}
                        onError={onError}
                        ref={this.ref}
                        searchOptions={{
                          componentRestrictions: { country: ["us"] }, // Only USA
                        }}
                        //googleCallbackName="myCallbackFunc"
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => {
                          if (
                            suggestions &&
                            suggestions.length > 0 &&
                            showSuggestions
                          ) {
                            this.suggestiondata = suggestions;
                          }
                          // else if (
                          //   localStorage.getItem("prvioussuggestions") &&
                          //   localStorage.getItem("prvioussuggestions") !==
                          //     undefined
                          // ) {
                          //   this.suggestiondata = JSON.parse(
                          //     localStorage.getItem("prvioussuggestions")
                          //   );
                          // }

                          return (
                            <div
                              style={{
                                margin: nhmap ? "" : "0 auto",
                                width: nhmap ? "" : "100%",
                              }}
                            >
                              <div
                                className={`ui input ${
                                  nhmap ? "map_search_box" : ""
                                }`}
                                id={nhmap ? "" : ""}
                                style={{
                                  width: nhmap ? "60%" : "100%",
                                  border: "1px solid #767676",
                                }}
                              >
                                <div
                                  className="ui large left icon input location-search-input"
                                  id={nhmap ? "" : "location_search"}
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    type="text"
                                    icon="search"
                                    iconposition="left"
                                    style={{ borderRadius: "0px" }}
                                    size="large"
                                    placeholder="Search..."
                                    {...getInputProps({
                                      placeholder: nhmap
                                        ? "Enter neighborhood, address or city"
                                        : "Search Neighborhood, City, Zip",
                                      className: "location-search-input",
                                      id: "place_auto_top",
                                    })}
                                    onClick={onClick}
                                    onKeyDown={onkeydown}
                                    ref={this.ref}
                                    // onChange={(e) => {this.setState({ searchValue: e.target.value }); onChange(e.target.value); }}
                                    // value={this.state.searchValue}
                                    //ref={input => searchref = input}
                                  />
                                  <i
                                    aria-hidden="true"
                                    className="search icon"
                                  ></i>
                                  {!is_loaded && (
                                    <img
                                      src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/loading.gif`}
                                      className="loadericon"
                                      title="Loader"
                                      alt="Loading"
                                    />
                                  )}
                                </div>
                                {filladdress && (
                                  <AiOutlineCloseCircle
                                    className="clear-data"
                                    onClick={() => handleCloseIconClick("")}
                                  />
                                )}
                              </div>
                              <div
                                className="autocomplete-dropdown-container"
                                style={{
                                  paddingLeft: "20px",
                                  width: bottomtabwidth,
                                  position: "absolute",
                                  zIndex: 999,
                                  backgroundColor: "#ffffff",
                                  textAlign: "left",
                                  visibility: "hidden",
                                  top: 50,
                                  left: 60,
                                }}
                              >
                                {this.suggestiondata.length > 0 &&
                                  this.suggestiondata.map((suggestion) => {
                                    if (
                                      suggestion.types.includes("premise") ||
                                      suggestion.types.includes("route") ||
                                      suggestion.types.includes("locality") ||
                                      suggestion.types.includes(
                                        "street_address"
                                      ) ||
                                      suggestion.types.includes("university") ||
                                      suggestion.types.includes("school") ||
                                      suggestion.types.includes("postal_code")
                                    ) {
                                      if (
                                        suggestion.types.includes("postal_code")
                                      ) {
                                        resultdata.push({
                                          label:
                                            suggestion.formattedSuggestion
                                              .mainText +
                                            " " +
                                            suggestion.formattedSuggestion
                                              .secondaryText,
                                          _type: suggestion.types,
                                        });
                                      } else {
                                        resultdata.push({
                                          label: suggestion.description,
                                          _type: suggestion.types,
                                        });
                                      }
                                    }
                                    //resultdata.push({"label":suggestion.description});
                                    let keys = ["label"];

                                    //     newsuggestions = resultdata.filter(
                                    //       (s => o =>
                                    //           (k => !s.has(k) && s.add(k))
                                    //           (keys.map(k => o[k]).join('|'))
                                    //       )
                                    //       (new Set)
                                    //   );

                                    let setObj = new Set(); // create key value pair from array of array
                                    let finalval = "";
                                    newsuggestions = resultdata.reduce(
                                      (acc, item) => {
                                        let homeaddress = "";
                                        homeaddress =
                                          item.UnparsedAddress +
                                          ", " +
                                          item.City +
                                          ", " +
                                          item.StateOrProvince;
                                        if (item.PostalCode !== null) {
                                          homeaddress += ", " + item.PostalCode;
                                        }

                                        if (item.label !== undefined) {
                                          let resArray = item.label.split(",");
                                          if (resArray.length > 3) {
                                            let poppedItem = resArray.pop();
                                            finalval = resArray.toString();
                                          } else {
                                            finalval = item.label;
                                          }
                                        } else if (
                                          item.UnparsedAddress !== undefined
                                        ) {
                                          finalval = item.UnparsedAddress;
                                        }
                                        if (
                                          showSuggestions &&
                                          item._type === undefined &&
                                          item.label !== undefined
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "neighborhood",
                                            id: item.id,
                                            nhfullname: item.nhfullname,
                                          });
                                        }

                                        if (
                                          item._type &&
                                          showSuggestions &&
                                          item._type.includes("postal_code")
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "zipcode",
                                          });
                                        }

                                        if (
                                          showSuggestions &&
                                          item._type === undefined &&
                                          item.School !== undefined
                                        ) {
                                          let schoolname = "";

                                          schoolname += item.School;
                                          if (item.City) {
                                            schoolname += ", " + item.City;
                                          }
                                          if (item.State) {
                                            schoolname += ", " + item.State;
                                          }

                                          dataarr.push({
                                            name: schoolname,
                                            category: "school",
                                            id: item.id,
                                          });
                                        }

                                        if (
                                          showSuggestions &&
                                          item._type === undefined &&
                                          item.UnparsedAddress !== undefined
                                        ) {
                                          dataarr.push({
                                            name: homeaddress,
                                            category: "address",
                                            id: item.ListingKeyNumeric,
                                          });
                                        } else if (
                                          item._type &&
                                          showSuggestions &&
                                          item._type.includes("locality")
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "locality",
                                          });
                                        }
                                        if (
                                          item._type &&
                                          showSuggestions &&
                                          (item._type.includes(
                                            "street_address"
                                          ) ||
                                            item._type.includes("premise") ||
                                            item._type.includes("route"))
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "googleaddress",
                                          });
                                        }
                                        if (
                                          item._type &&
                                          showSuggestions &&
                                          item._type.includes("university")
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "university",
                                          });
                                        }
                                        // if (
                                        //   item._type &&
                                        //   showSuggestions &&
                                        //   item._type.includes("school")
                                        // ) {
                                        //   dataarr.push({
                                        //     name: item.label,
                                        //     category: "school",
                                        //   });
                                        // }
                                        dataarr.length > 0 &&
                                          dataarr.map((x) =>
                                            unique.filter(
                                              (a) => a.name == x.name
                                            ).length > 0
                                              ? null
                                              : unique.push(x)
                                          );

                                        //check exaxct match
                                        let filterdarr = unique.filter(
                                          (x) =>
                                            x.name
                                              .toLowerCase()
                                              .indexOf(
                                                searchquery.toLowerCase()
                                              ) === 0
                                        );

                                        result =
                                          filterdarr.length > 0 &&
                                          filterdarr.reduce(function (r, a) {
                                            r[a.category] = r[a.category] || [];
                                            r[a.category].push(a);
                                            return r;
                                          }, Object.create(null));

                                        if (!setObj.has(finalval)) {
                                          setObj.add(finalval, item);
                                          acc.push(item);
                                        }
                                        return acc;
                                      },
                                      []
                                    );

                                    // if (
                                    //   result.address &&
                                    //   result.address.length > 0
                                    // ) {
                                    //   result.address.slice(0, 7);
                                    // }

                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          paddingTop: "5px",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          paddingTop: "5px",
                                        };
                                    return (
                                      <div className="suggestions_name">
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                              </div>

                              {addresslength > 0 && (
                                <div
                                  className="autocomplete-dropdown-container"
                                  style={{
                                    width: bottomtabwidth,
                                    position: "absolute",
                                    zIndex: 999,
                                    backgroundColor: "#ffffff",
                                    textAlign: "left",
                                    top: 56,
                                    borderColor:
                                      "currentcolor rgb(200, 200, 200) rgb(200, 200, 200)",
                                    borderStyle: "none solid",
                                    borderWidth: "medium 1px 1px",
                                    borderRadius: "0px 0px 4px 4px",
                                    left: nhmap ? "" : "",
                                    //	margin: nhmap ? '' :'0 auto'
                                  }}
                                >
                                  <div className="suggestions_name">
                                    {result &&
                                      result.neighborhood &&
                                      result.neighborhood.length > 0 &&
                                      result.neighborhood.map((item, index) => {
                                        checknodata = true;
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="home" />{" "}
                                                Neighborhood
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name === userInput
                                                  ? "suggestion-active"
                                                  : "suggestions_name"
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                handleSelect(
                                                  e,
                                                  this.suggestiondata,
                                                  "neighborhood",
                                                  item.nhfullname
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "20px",
                                              }}
                                            >
                                              {item.name}
                                            </p>

                                            {index + 1 ===
                                              result.neighborhood.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.zipcode &&
                                      result.zipcode.length > 0 &&
                                      result.zipcode.map((item, index) => {
                                        checknodata = true;
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="home" /> Zipcode
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name === userInput
                                                  ? "suggestion-active"
                                                  : "suggestions_name"
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                handleSelect(
                                                  e,
                                                  this.suggestiondata,
                                                  "neighborhood",
                                                  item.name
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "20px",
                                              }}
                                            >
                                              {item.name}
                                            </p>

                                            {index + 1 ===
                                              result.zipcode.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.address &&
                                      result.address.length > 0 &&
                                      result.address.map((item, index) => {
                                        checknodata = true;
                                        count++;
                                        // if (index <= 6) {
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="street view" />{" "}
                                                Listing Addresses
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name === userInput
                                                  ? "suggestion-active"
                                                  : "suggestions_name"
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                handleSelect(
                                                  e,
                                                  this.suggestiondata,
                                                  item.id ? "street" : "",
                                                  item.id ? item.id : item.name
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "20px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.address.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                        // }
                                      })}

                                    {result &&
                                      result.locality &&
                                      result.locality.length > 0 &&
                                      result.locality.map((item, index) => {
                                        checknodata = true;
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="building" /> City
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name === userInput
                                                  ? "suggestion-active"
                                                  : "suggestions_name"
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                handleSelect(
                                                  e,
                                                  this.suggestiondata,
                                                  "city",
                                                  item.name
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "20px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.locality.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.university &&
                                      result.university.length > 0 &&
                                      result.university.map((item, index) => {
                                        checknodata = true;
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="university" />{" "}
                                                University
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name === userInput
                                                  ? "suggestion-active"
                                                  : "suggestions_name"
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                handleSelect(
                                                  e,
                                                  this.suggestiondata,
                                                  "university",
                                                  item.name
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "20px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.university.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.school &&
                                      result.school.length > 0 &&
                                      result.school.map((item, index) => {
                                        checknodata = true;
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="graduation cap" />{" "}
                                                School
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name === userInput
                                                  ? "suggestion-active"
                                                  : "suggestions_name"
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                handleSelect(
                                                  e,
                                                  this.suggestiondata,
                                                  "school",
                                                  item.name
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "20px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {/* {index + 1 === result.school.length && <div style={{borderBottom:"1px solid rgb(200, 200, 200)"}}></p> }div*/}
                                            {index + 1 ===
                                              result.school.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.googleaddress &&
                                      result.googleaddress.length > 0 &&
                                      result.googleaddress.map(
                                        (item, index) => {
                                          checknodata = true;
                                          count++;
                                          //if (index <= 6) {
                                          return (
                                            <>
                                              {index === 0 && (
                                                <div className="nh_search">
                                                  <Icon name="street view" />{" "}
                                                  All Addresses
                                                </div>
                                              )}
                                              <p
                                                className={
                                                  item.name === userInput
                                                    ? "suggestion-active"
                                                    : "suggestions_name"
                                                }
                                                id={count}
                                                onClick={(e) =>
                                                  handleSelect(
                                                    e,
                                                    this.suggestiondata,
                                                    item.id ? "street" : "",
                                                    item.id
                                                      ? item.id
                                                      : item.name
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  paddingLeft: "20px",
                                                }}
                                              >
                                                {item.name}
                                              </p>
                                              {index + 1 ===
                                                result.googleaddress.length && (
                                                <div
                                                  style={{
                                                    borderBottom:
                                                      "1px solid rgb(200, 200, 200)",
                                                  }}
                                                ></div>
                                              )}
                                            </>
                                          );
                                          //}
                                        }
                                      )}

                                    {!checknodata &&
                                      is_loaded &&
                                      addresslength > 2 &&
                                      showSuggestions && (
                                        <p className="no_result_searchbox suggestions_name">
                                          No result found
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        }}
                      </PlacesAutocomplete>
                    )}
                  </Menu.Item>
                ) : null}
              </div>
            </div>
            <div className="nav-section-btns">
              {isTablet ? (
                ""
              ) : (
                <button className="realtor-btn">
                  <a href="/agentlanding" title="Agents">
                    Agents
                  </a>
                </button>
              )}
              <Menu className="menu_blk" text style={{ margin: 0 }}>
                <Menu.Menu className="nav-sign">
                  <Menu.Item className="item-wrapper">
                    {username ? (
                      <div>
                        {isTablet && (
                          <Dropdown
                            item
                            icon="list layout"
                            className="icon nav_menu_icon"
                          >
                            <Dropdown.Menu>
                              <Button.Group vertical>
                                {/* {!ishome && <a href={urls}>
                                <ButtonItem basic color="black" className="nav_btn" title="Home" />
                              </a> } */}
                                <a href={urls} title="Map">
                                  <ButtonItem
                                    basic
                                    color="black"
                                    className="nav_btn"
                                    title="Map"
                                    onClick={() => homeclick(urls)}
                                  />
                                </a>
                                <Link href={page}>
                                  <ButtonItem
                                    name="myaccount"
                                    className="nav_btn"
                                    basic
                                    color="black"
                                    title="My Account"
                                  />
                                </Link>
                                <ButtonItem
                                  name="logout"
                                  className="nav_btn"
                                  basic
                                  color="black"
                                  title="Sign Out"
                                  onClick={(e) => button(e)}
                                />
                                <a
                                  href="/agentlanding"
                                  title="Real Estate Agents"
                                >
                                  <ButtonItem
                                    name="realEstateAgents"
                                    className="nav_btn"
                                    basic
                                    color="black"
                                    title="Real Estate Agents"
                                  />
                                </a>
                              </Button.Group>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                        <Desktop>
                          <div>
                            <Button.Group className="nav_btn_container">
                              {/* {!ishome &&  <a href={urls}>
                                <ButtonItem basic color="grey" className="nav_btn" title="Home" />
                              </a>} */}
                              <a href={urls} title="Map">
                                <ButtonItem
                                  basic
                                  color="grey"
                                  className="nav_btn br-round-left"
                                  title="Map"
                                  onClick={() => homeclick(urls)}
                                />
                              </a>
                              <Link href={page}>
                                <ButtonItem
                                  name="myaccount"
                                  className="nav_btn"
                                  basic
                                  color="grey"
                                  title="My Account"
                                />
                              </Link>
                              <ButtonItem
                                name="logout"
                                className="nav_btn br-round-right"
                                basic
                                color="grey"
                                title="Sign Out"
                                onClick={(e) => button(e)}
                              />
                            </Button.Group>
                          </div>
                        </Desktop>
                      </div>
                    ) : (
                      <div>
                        {isTablet && (
                          <Dropdown
                            item
                            icon="list layout"
                            className="icon nav_menu_icon"
                          >
                            <Dropdown.Menu>
                              <Button.Group vertical>
                                {/* {!ishome && <a href={urls}><ButtonItem name="home" basic color="black" className="nav_btn"  title="Home" /></a>} */}
                                <a href={urls} title="Map">
                                  <ButtonItem
                                    name="home"
                                    basic
                                    color="black"
                                    className="nav_btn"
                                    title="Map"
                                    onClick={() => homeclick(urls)}
                                  />
                                </a>
                                <Link href="#">
                                  <ButtonItem
                                    name="signup"
                                    basic
                                    color="black"
                                    className="nav_btn"
                                    title="Sign Up"
                                    onClick={(e) => button(e)}
                                    id="sign_up_btn"
                                  />
                                </Link>
                                <Link href="#">
                                  <ButtonItem
                                    name="login"
                                    basic
                                    color="black"
                                    className="nav_btn"
                                    title="Sign In"
                                    onClick={(e) => button(e)}
                                    id="sign_in_btn"
                                  />
                                </Link>
                                <a
                                  href="/agentlanding"
                                  title="Real Estate Agents"
                                >
                                  <ButtonItem
                                    name="realEstateAgents"
                                    className="nav_btn"
                                    basic
                                    color="black"
                                    title="Agents"
                                  />
                                </a>
                              </Button.Group>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                        {/* </Responsive> */}
                        <Desktop>
                          <div>
                            <Button.Group className="nav_btn_container">
                              {/* {!ishome && <a href={urls}><ButtonItem basic className="nav_btn"  color="grey" title="Home" floated="right"/></a>} */}
                              <a href={urls} title="Map">
                                <ButtonItem
                                  basic
                                  className="nav_btn br-round-left"
                                  color="grey"
                                  title="Map"
                                  floated="right"
                                  onClick={() => homeclick(urls)}
                                />
                              </a>
                              <ButtonItem
                                name="signup"
                                basic
                                color="grey"
                                className="nav_btn"
                                title="Sign Up"
                                floated="right"
                                onClick={(e) => button(e)}
                                id="sign_up_btn"
                              />
                              <ButtonItem
                                name="login"
                                basic
                                color="grey"
                                className="nav_btn br-round-right"
                                title="Sign In"
                                floated="right"
                                onClick={(e) => button(e)}
                                id="sign_in_btn"
                              />
                            </Button.Group>
                          </div>
                        </Desktop>
                      </div>
                    )}
                  </Menu.Item>
                </Menu.Menu>
              </Menu>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Nav;
